<template>
    <div class="tree-drop-down" :class="{ open: showTree }">
        <div class="drop-down-display" >
            <template v-for="(item,indexItem) in path" >
                <span class="item-label" @click="handleClickBreadcrumb(item, $event)" tabindex="0" >
                    <i class="fa-fw" :class="typeIcon(item)"></i>
                    {{ item.name }}
                </span>
                <span v-if="!isLast(indexItem)" class="separator" @click.stop="">
                    <i class="fa fa-angle-right"></i>
                </span>
            </template>
            <div class="tree-toggle" @click="toggleTree" tabindex="0">
                <i class="fa fa-caret-down"></i>
            </div>
        </div>
        <div class="tree-container scroll" v-on-clickaway="closeTree">
            <Tree 
                :treeData="treeData" 
                :options="treeOptions" 
                :selected="selected" 
                :icons="icons" 
                @treeNodeClick='onNodeClick'
            />
        </div>

    </div>

</template>

<script>
    import Tree from './Tree'

    import Utils from '@/services/utils.js';
    import Icons from '@/services/iconMapping.js';

    import {mixin as clickaway} from 'vue-clickaway';

    export default {
        components: {
            Tree
        },
        mixins: [clickaway],
        name: 'treedropdown',
        props: {
            treeData: [Array],
            treeOptions: [Object],
            icons: {
                type: [Object],
                default: function(){
                    return {}
                }
            },
            selected: {
                type: Object,
                default: null
            },
        },
        data () {
            return {
                showTree: false,
                treeFirstTime: true,
                path: []
            }
        },
        methods: {
            handleClickBreadcrumb: function(node,evt){

                evt.stopPropagation();
                evt.preventDefault();
                if(Utils.isAPable(node.type)){
                    this.$emit('treeNodeClick', node);
                }
                return false;
            },
            onNodeClick: function (node) {
                this.getCompletePath(node);
                this.toggleTree();
                this.$emit('treeNodeClick', node);
            },
            onNodeRightClick: function (evt,node) {
                this.$emit('treeNodeRightClick', evt, node);
            },
            unactivateNodes: function (nodeToKeep) {

                for (var node in this.treeData) {
                    this.unactivateNode(this.treeData[node], nodeToKeep);
                }

            },
            unactivateNode: function (node, nodeToKeep) {

                if (nodeToKeep == null) {
                    node.active = false;
                    return;
                }

                if (node.id != nodeToKeep.id) {
                    node.active = false;
                }

                if (node.children != null) {
                    for (var node2 in node.children) {
                        this.unactivateNode(node.children[node2], nodeToKeep);
                    }
                }
            },
            activateNode: function(node){
                node.active = true;
            },
            forceHeight: function (node) {
                if (node.children && node.children.length > 0) {
                    for (var child in node.children) {
                        node.children[child].opened = true;
                        this.forceHeight(node.children[child]);
                    }
                }
            },
            toggleTree: function(){
                this.showTree = !this.showTree;
                if(!this.showTree){
                    this.treeFirstTime = true;
                }
            },
            closeTree: function(){
                if (this.showTree && !this.treeFirstTime) {
                    this.showTree = false;
                    this.treeFirstTime = true;
                } else {
                    this.treeFirstTime = false;
                }
            },
            typeIcon: function(item){
                return Icons.plans[item.type];
            },
            isLast: function(index){
                return index >= this.path.length-1;
            },
            getCompletePath: function(node){
                var vThis = this;
                var path = node.pathOrder.split('.');
                var pathAll = [];

                path.forEach(function(id){

                    var pathObj = Utils.getByIdInTree(vThis.treeData,id);
                    if(pathObj){
                        pathAll.push(pathObj);
                    }

                });
                pathAll.push(node);

                this.path = pathAll;
            }
        },
        mounted: function () {

            for (var child in this.treeData) {
                this.treeData[child].opened = true;
                this.forceHeight(this.treeData[child]);
            }

        },
        watch: {
            selected: function(newValue){
                if(newValue != null){
                    this.getCompletePath(newValue);
                }

            }
        }
    }
</script>

<style scoped>

</style>

